import Config from 'config';
import { sessionManager } from 'vue-infra';
import { TABS } from '@/common/consts';
import { FEATURES, PRIVILEGES } from '@/store/modules/data/logged-in-user/consts';

/* eslint-disable global-require */
const MyConnectionsPage = r => require.ensure([], () => r(require('@/components/my-connections/my-connections-page.vue')), 'MyConnectionsPage');
const AllConnectionsPage = r => require.ensure([], () => r(require('@/components/all-connections/all-connections-page.vue')), 'AllConnectionsPage');
const AllTasksPage = r => require.ensure([], () => r(require('@/components/all-tasks/all-tasks-page.vue')), 'AllTasksPage');
const AgentListPage = r => require.ensure([], () => r(require('@/components/agent-list/agent-list-page.vue')), 'AgentListPage');
const MainLayout = r => require.ensure([], () => r(require('@/components/layout/main-layout.vue')), 'MainLayout');
/* eslint-enable global-require */

const routes = [{
  path: `/aw/${TABS.MY_CONNECTIONS}/:id?`,
  name: TABS.MY_CONNECTIONS,
  components: { aw: MyConnectionsPage },
  meta: { layout: MainLayout },
}, {
  path: `/aw/${TABS.ALL_CONNECTIONS}`,
  name: TABS.ALL_CONNECTIONS,
  components: { aw: AllConnectionsPage },
  props: { aw: true },
  meta: { layout: MainLayout },
  beforeEnter(to, from, next) {
    const hasMessagingHistoryPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MESSAGING_HISTORY_PRIVILEGE));
    const hasViewActiveConnections = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ACTIVE_CONNECTIONS));
    const isLPA = sessionManager.isLPA();
    if (isLPA || (hasMessagingHistoryPrivilege && hasViewActiveConnections)) {
      next();
    } else {
      next(false);
    }
  },
}, {
  path: `/aw/${TABS.ALL_TASKS}`,
  name: TABS.ALL_TASKS,
  components: { aw: AllTasksPage },
  meta: { layout: MainLayout },
  beforeEnter(to, from, next) {
    const hasAgentAnnotationsFeature = sessionManager.getFeaturePropertyState(FEATURES.HANDLE_INTENT_ANNOTATIONS);
    const hasMessagingHistoryPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MESSAGING_HISTORY_PRIVILEGE));
    const hasViewAllTasksPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ALL_TASKS));
    const isLPA = sessionManager.isLPA();
    if (hasAgentAnnotationsFeature && (hasViewAllTasksPrivilege ||
      (isLPA && hasMessagingHistoryPrivilege))) {
      next();
    } else {
      next(false);
    }
  },
}, {
  path: `/aw/${TABS.AGENT_LIST}`,
  name: TABS.AGENT_LIST,
  components: { aw: AgentListPage },
  meta: { layout: MainLayout },
}, {
  path: '/aw/*',
  name: 'default',
  redirect: { path: `/${Config.applicationName}/${TABS.MY_CONNECTIONS}` },
  meta: { layout: MainLayout },
}];

export default routes;
